import { z } from 'zod';
export const ScanType = z.enum(['ATTENDANCE', 'LUNCH']);
export const ScanResult = z.enum(['OK', 'DUPLICATE', 'INVALID', 'REVOKED']);
export const SHORT_CODE_LENGTH = 6;
export const SHORT_CODE_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export const QrTokenSchema = z.string().uuid();
export const ShortCodeSchema = z.string().regex(/^[A-Z0-9]{6}$/);
export const ScanEmailSchema = z.string().trim().toLowerCase().email();
/**
 * Acepta cualquier string no vacío en cliente; la normalización a E.164
 * (+57XXXXXXXXX) la hace `normalizeColombianPhone` en `@ticketing/shared/utils`.
 * El servicio rechaza el lookup si la normalización no produce un móvil CO.
 */
export const ScanPhoneSchema = z.string().trim().min(1);
export const ScanInput = z.union([
    z.object({ qrToken: QrTokenSchema, type: ScanType }),
    z.object({ shortCode: ShortCodeSchema, type: ScanType }),
    z.object({ email: ScanEmailSchema, type: ScanType }),
    z.object({ phone: ScanPhoneSchema, type: ScanType }),
]);
export const ScanOutput = z.object({
    result: ScanResult,
    attendee: z
        .object({
        id: z.string().uuid(),
        fullName: z.string(),
        email: z.string().email(),
    })
        .nullable(),
    message: z.string(),
    firstScan: z
        .object({
        scannedAt: z.string().datetime(),
        by: z.object({
            id: z.string().uuid(),
            fullName: z.string(),
        }),
    })
        .nullable(),
});
export const ScanLogItem = z.object({
    id: z.string().uuid(),
    type: ScanType,
    result: ScanResult,
    scannedAt: z.string().datetime(),
    attendee: z
        .object({ id: z.string().uuid(), fullName: z.string(), email: z.string().email() })
        .nullable(),
    attemptedToken: z.string().nullable(),
    note: z.string().nullable(),
    by: z.object({ id: z.string().uuid(), fullName: z.string() }),
});
export const ScanLogsQuery = z.object({
    type: ScanType.optional(),
    result: ScanResult.optional(),
    email: z.string().trim().min(1).optional(),
    eventId: z.string().uuid().optional(),
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(100).default(50),
});
export const ScanLogsResponse = z.object({
    items: z.array(ScanLogItem),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
//# sourceMappingURL=scan.js.map